/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import * as go from 'gojs';

import { highlightPath } from '../../../helpers/graph';
import { NODE_STYLES } from '../graph-config';
import { GoMake } from './shared';

/**
 * Start node template (circle with centered play-triangle icon)
 */
export function createStartNodeTemplate($: GoMake): go.Node {
  return $(
    go.Node,
    'Spot',
    {
      selectionAdorned: false,
      layoutConditions: go.LayoutConditions.Added | go.LayoutConditions.Removed,
      locationSpot: go.Spot.Center,
      mouseEnter: (_e: go.InputEvent, obj: go.GraphObject) => {
        highlightPath(obj as go.Node, null, true, true);
      },
      mouseLeave: (_e: go.InputEvent, obj: go.GraphObject) => {
        highlightPath(obj as go.Node, null, false, true);
      },
    },
    new go.Binding('location', 'location', go.Point.parse, go.Point.stringify),
    // Inner Auto panel for proper sizing
    $(
      go.Panel,
      'Auto',
      $(go.Shape, NODE_STYLES.start.shape, {
        desiredSize: NODE_STYLES.start.size,
        fill: NODE_STYLES.start.fill,
        stroke: NODE_STYLES.start.stroke,
        strokeWidth: NODE_STYLES.start.strokeWidth,
      }),
      // Play triangle icon centered inside the circle
      $(go.Picture, {
        desiredSize: NODE_STYLES.start.icon.size,
        imageStretch: go.ImageStretch.Uniform,
      },
      new go.Binding('source', 'source'))
    ),
    // Bottom port for connection to first turn
    $(go.Shape, 'Circle', {
      width: 2,
      height: 2,
      fill: 'transparent',
      stroke: 'transparent',
      portId: 'bottom',
      alignment: go.Spot.Bottom,
      fromLinkable: true,
      toLinkable: true,
    })
  );
}
